<template>
  <div :class="{'highligted': isHighligted}" class="divider"></div>
</template>

<script>
export default {
  props: {
    isHighligted: {type: Boolean, default: false}
  }
};
</script>

<style lang="scss" scoped>
.divider {
  flex-grow: 1;
  margin: 19px -7px;
  align-self: baseline;
  &.highligted {
    border-bottom: 2px solid var(--secondary);
  }

  &:not(.highligted) {
    border-bottom: 2px solid var(--mid-gray);
    opacity: 0.5;
  }
}
</style>
